import { render, staticRenderFns } from "./RatingTotal.vue?vue&type=template&id=d42138a2&scoped=true"
import script from "./RatingTotal.vue?vue&type=script&lang=js"
export * from "./RatingTotal.vue?vue&type=script&lang=js"
import style0 from "./RatingTotal.vue?vue&type=style&index=0&id=d42138a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42138a2",
  null
  
)

export default component.exports